import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Avatar from "@mui/material/Avatar";
import ForumRespondIcon from "@mui/icons-material/Group";
import ForumRespondNewIcon from "@mui/icons-material/Person";
import MissingIcon from "@mui/icons-material/Help";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Typography from "@mui/material/Typography";
//Limitless imports
import FeeReview from "@limitless/icons/FeeReview";
import RespondStickyIcon from "@limitless/icons/RespondStickyIcon";
import QualityReview from "@limitless/icons/QualityReview";
import EscalationReview from "@limitless/icons/EscalationReview";
import RespondIcon from "@limitless/icons/RespondIcon";
import RespondNewIcon from "@limitless/icons/RespondNewIcon";
import { useExpertProfileContext } from "@limitless/expert";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import { TASK_TYPE_LABEL } from "@limitless/expert/hooks/expert-task-list/TaskListHelper";

export const TASK_TYPE_ICON_MAP = {
    respond: {
        component: RespondIcon
    },
    respondExisting: {
        component: RespondIcon
    },
    new: {
        component: RespondNewIcon,
        class: "newItemIcon",
        iconClass: "newIconClass"
    },
    respondNew: {
        component: RespondNewIcon,
        class: "newItemIcon",
        iconClass: "newIconClass"
    },
    respondSticky: {
        component: RespondStickyIcon,
        class: "stickyIcon",
        iconClass: "stickyIconClass"
    },
    sticky: {
        component: RespondStickyIcon,
        class: "stickyIcon"
    },
    review: {
        component: FeeReview,
        class: "reviewIconClass"
    },
    reviewFee: {
        component: FeeReview,
        class: "reviewIconClass"
    },
    reviewDetailed: {
        component: QualityReview,
        class: "reviewIconClass"
    },
    reviewQuality: {
        component: QualityReview,
        class: "reviewIconClass"
    },
    reviewEscalation: {
        component: EscalationReview,
        class: "reviewIconClass"
    },
    missing: {
        component: MissingIcon,
        class: "itemIcon"
    },
    forumrespondNew: {
        component: ForumRespondNewIcon,
        class: "itemIcon"
    },
    forumrespond: {
        component: ForumRespondIcon,
        class: "itemIcon"
    },
    forumrespondSticky: {
        component: RespondStickyIcon,
        class: "stickyIcon"
    },
    pass: {
        component: RespondNewIcon,
        class: "passIconClass"
    },
    Fee: {
        component: AttachMoneyIcon,
        iconClass: "feeIcon",
        class: "itemIcon"
    }
};

const useStyles = makeStyles(theme => ({
    smallIcon: {
        width: 21,
        height: 21
    },
    taskIcon: {
        width: 50,
        height: 50,
        margin: "0px 8px 0 8px"
    },
    stickyIcon: {
        backgroundColor: theme.palette.warning.light
    },
    itemIcon: {
        backgroundColor: theme.palette.primary.main
    },
    newItemIcon: {
        backgroundColor: theme.palette.primary.light
    },
    passIconClass: {
        backgroundColor: theme.palette.error.main
    },
    icon: {
        fontSize: ({ size }) => (size === "small" ? 11 : 20),
        color: theme.palette.primary.contrastText
    },
    reviewIconClass: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    stickyIconClass: {
        color: theme.palette.secondary.contrastText
    },
    feeIcon: {
        fontSize: "18px !important",
        color: theme.palette.primary.contrastText
    },
    feeContainer: {
        fontSize: "12px !important",
        color: theme.palette.primary.contrastText
    }
}));

const ModernTaskListAvatar = ({ type, size = "medium", isTooltipShow = false, ...rest }) => {
    const classes = useStyles({ size });
    const {
        profile: { balanceCurrencySymbol }
    } = useExpertProfileContext();

    // let taskType = isPassed ? TASK_TYPE_ICON_MAP["pass"] : TASK_TYPE_ICON_MAP[type];
    let taskType = TASK_TYPE_ICON_MAP[type];
    taskType = taskType || TASK_TYPE_ICON_MAP["missing"];

    const icon = React.useMemo(() => {
        const DisplayIcon = taskType.component;

        return type === "Fee" ? (
            <Typography className={classes.feeContainer}>{balanceCurrencySymbol}</Typography>
        ) : (
            <DisplayIcon className={`${classes[taskType.iconClass]} ${classes.icon}`} size={size} />
        );
    }, [classes, type]);

    return isTooltipShow ? (
        <IconButton
            icon={icon}
            label={TASK_TYPE_LABEL[type]?.label}
            onClick={() => null}
            id="respondStickyIfoButton"
            className={`${size === "small" ? classes.smallIcon : classes.taskIcon} ${classes[`${taskType.class}`]}`}
            {...rest}
        />
    ) : (
        <Avatar
            className={`${size === "small" ? classes.smallIcon : classes.taskIcon} ${classes[`${taskType.class}`]}`}
            {...rest}
        >
            {icon}
        </Avatar>
    );
};

export default ModernTaskListAvatar;

ModernTaskListAvatar.propTypes = {
    type: PropTypes.string.isRequired,
    size: PropTypes.string,
    isTooltipShow: PropTypes.bool
};
